import { Rating } from 'react-simple-star-rating';

const RatingAndWishlist = (props) => {
    const { item, rating,onWishlistToggle } = props;

    return (
        <div className="product_content_wepper mt-0">
            <div className="d-flex justify-content-between align-items-center" style={{ paddingRight: '5px' }}>
                <div className="product-item">
                    <div className="product-rating d-flex align-items-center">
                        <Rating
                            initialValue={rating}
                            readonly
                            size={20}
                            label={`Rating: ${rating}`}
                            fractions={2}
                        />
                    </div>
                </div>
                <div className="wishlist_icon">
                    <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width="20"
                        height="20"
                        style={{ enableBackground: 'new 0 0 512 512' }}
                        onClick={() => onWishlistToggle(item)}
                    >
                        <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                            <path
                                d="M368,32c73.627-0.011,133.323,59.669,133.333,133.296c0,0.011,0,0.027,0,0.037C501.333,298.667,298.667,480,256,480S10.667,298.667,10.667,165.333C10.661,91.701,70.347,32.005,143.979,32c45.28-0.005,87.467,22.976,112.021,61.013C280.533,54.96,322.725,31.979,368,32z"
                                fill={item?.wishStatus === false ? '#00000030' : '#f54b55'}
                                fillOpacity="1"
                                stroke="none"
                            />
                            <g style={{ opacity: 0.08 }}>
                                <path
                                    d="M256,426.667c-39.845,0-219.173-158.133-242.725-287.643c-1.733,8.661-2.608,17.477-2.608,26.309C10.667,298.667,213.333,480,256,480s245.333-181.333,245.333-314.667c0-8.832-0.875-17.648-2.608-26.309C475.173,268.533,295.845,426.667,256,426.667z"
                                    fill={item?.wishStatus === false ? '#00000030' : '#f54b55'}
                                    fillOpacity="1"
                                    stroke="none"
                                />
                            </g>
                            <path
                                d="M256,490.667c-52.048,0-256-190.309-256-325.333c0-49.115,24.629-94.341,65.893-120.981c62.363-40.267,144.491-26.064,190.101,30.469c27.163-33.744,67.989-53.488,111.941-53.488c0.027,0,0.043,0,0.069,0h0.037c79.392,0.011,143.968,64.608,143.957,144C512,300.357,308.053,490.667,256,490.667z M143.797,42.699c-22.779,0-45.808,6.325-66.336,19.573c-35.147,22.693-56.128,61.221-56.128,103.061c0,127.339,199.355,304,234.667,304s234.667-176.661,234.667-304c0.011-67.632-54.997-122.656-122.624-122.667c-0.005,0-0.048,0-0.048,0c-0.016,0-0.043,0-0.059,0c-41.819,0-80.309,20.976-102.976,56.128c-1.957,3.045-5.333,4.885-8.96,4.885l0,0c-3.621,0-6.997-1.84-8.96-4.885C223.605,62.496,184.096,42.699,143.797,42.699z"
                                fill={item?.wishStatus === false ? '#00000030' : '#f54b55'}
                                fillOpacity="1"
                                stroke="none"
                            />
                        </g>
                    </svg>
                </div> 
            </div>
            <div className="price_wrapper d-flex my-2">
                <p className="unit_price">₹{item.unitPrice}</p>
                <del>₹{item.mrp}</del>
            </div>
        </div>
    )
}

export default RatingAndWishlist;